import type { CSSProperties } from 'react';

/** Bottom edge of the caret line in viewport coordinates (for anchoring popovers). */
export function getTextareaCaretBottom(textarea: HTMLTextAreaElement, caretIndex: number): number {
  const rect = textarea.getBoundingClientRect();
  const style = window.getComputedStyle(textarea);
  const lineHeight = Number.parseFloat(style.lineHeight) || Number.parseFloat(style.fontSize) * 1.2 || 18;
  const paddingTop = Number.parseFloat(style.paddingTop) || 0;
  const textBefore = textarea.value.slice(0, caretIndex);
  const lineIndex = textBefore.split('\n').length - 1;
  const lineBottomInTextarea = paddingTop + (lineIndex + 1) * lineHeight - textarea.scrollTop;
  return rect.top + Math.max(lineHeight, lineBottomInTextarea);
}

export type MentionMenuPlacement = 'above' | 'below';

const MENU_GAP = 4;
const VIEWPORT_PADDING = 8;
const MENU_MAX_HEIGHT = 208;

export function computeMentionMenuStyle(
  textarea: HTMLTextAreaElement,
  caretIndex: number,
): { placement: MentionMenuPlacement; style: CSSProperties } {
  const rect = textarea.getBoundingClientRect();
  const caretBottom = getTextareaCaretBottom(textarea, caretIndex);
  const caretTop = caretBottom - (Number.parseFloat(window.getComputedStyle(textarea).lineHeight) || 18);

  const spaceBelow = window.innerHeight - caretBottom - VIEWPORT_PADDING;
  const spaceAbove = caretTop - VIEWPORT_PADDING;
  const placeAbove = spaceBelow < MENU_MAX_HEIGHT && spaceAbove > spaceBelow;

  let left = rect.left;
  const width = rect.width;
  if (left + width > window.innerWidth - VIEWPORT_PADDING) {
    left = Math.max(VIEWPORT_PADDING, window.innerWidth - VIEWPORT_PADDING - width);
  }
  left = Math.max(VIEWPORT_PADDING, left);

  if (placeAbove) {
    return {
      placement: 'above',
      style: {
        position: 'fixed',
        left,
        width,
        top: caretTop - MENU_GAP,
        transform: 'translateY(-100%)',
        maxHeight: Math.min(MENU_MAX_HEIGHT, Math.max(120, spaceAbove - MENU_GAP)),
      },
    };
  }

  return {
    placement: 'below',
    style: {
      position: 'fixed',
      left,
      width,
      top: caretBottom + MENU_GAP,
      maxHeight: Math.min(MENU_MAX_HEIGHT, Math.max(120, spaceBelow - MENU_GAP)),
    },
  };
}
